import { useQuery } from "@tanstack/react-query";
import type { ProductSize, ProductTypeOption } from "../models/ProductSize";
import {
	getActiveProductTypes,
	getProductSizes,
} from "../repositories/ProductSizesRepository";

export const PRODUCT_SIZES_QUERY_KEYS = {
	all: ["productSizes"] as const,
	list: () => ["productSizes", "list"] as const,
	byId: (id: number | null) => ["productSizes", "detail", id] as const,
	productTypes: ["productSizes", "productTypes"] as const,
};

export const useProductSizes = () => {
	const query = useQuery<ProductSize[], Error>({
		queryKey: PRODUCT_SIZES_QUERY_KEYS.list(),
		queryFn: () => getProductSizes(),
	});

	return {
		productSizes: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};

export const useActiveProductTypes = () => {
	return useQuery<ProductTypeOption[], Error>({
		queryKey: PRODUCT_SIZES_QUERY_KEYS.productTypes,
		queryFn: getActiveProductTypes,
		staleTime: 5 * 60 * 1000,
	});
};
